// extracted by mini-css-extract-plugin
export var center = "_54-2";
export var clickableRow = "_54-5";
export var expandedRow = "_54-7";
export var hoverable = "_54-4";
export var left = "_54-1";
export var right = "_54-3";
export var row = "_54-0";
export var selectedRow = "_54-6";
export var summaryRow = "_54-8";